<template>
    <v-container id="ra-general-information" fluid>
        <v-card-subtitle class="pb-0 px-0">
            <v-icon :color="kingsGold" left>mdi-medical-bag</v-icon>Standard First Aid Training
            <br>
            You are required to complete Standard First Aid training (Typically a 2 day course) prior to
            training week and
            provide proof of certification. King’s does not reimburse the cost of the training.
        </v-card-subtitle>
        <v-row>
            <v-col cols="12" lg="4">
                <v-text-field v-model="item.firstAidTrainingInitials" label="I understand (please initial)"
                    prepend-icon="mdi-draw" :rules="firstAidTrainingInitialsRules" required>
                </v-text-field>
            </v-col>
        </v-row>
        <v-card-subtitle class="pb-0 px-0">
            <v-icon :color="kingsGold" left>mdi-card-account-details</v-icon>Canadian Social Insurance
            Number
            <br>
            You are required to have a Canadian Social Insurance Number card (SIN) by the end of August
            for payroll
            purposes.
        </v-card-subtitle>
        <v-row>
            <v-col cols="12" lg="4">
                <v-text-field v-model="item.sinCardInitials" label="I understand (please initial)"
                    prepend-icon="mdi-draw" :rules="sinCardInitialsRules" required>
                </v-text-field>
            </v-col>
        </v-row>
        <v-card-subtitle class="pb-0 px-0">
            <v-icon :color="kingsGold" left>mdi-allergy</v-icon>Food/Allergies Concern(s)
            Number
            <br>
            Please advise us of any other allergies, food concerns or circumstances that you feel we
            should know about when planning RA training week.
        </v-card-subtitle>
        <v-row>
            <v-col cols="12">
                <v-checkbox v-model="item.allergiesType" dense hide-details label="Vegetarian" multiple
                    value="Vegetarian">
                </v-checkbox>
                <v-checkbox v-model="item.allergiesType" dense hide-details label="Vegan" multiple value="Vegan">
                </v-checkbox>
                <v-checkbox v-model="item.allergiesType" dense hide-details label="Gluten Intolerant" multiple
                    value="Gluten Intolerant">
                </v-checkbox>
                <v-checkbox v-model="item.allergiesType" dense hide-details label="Lactose Intolerant" multiple
                    value="Lactose Intolerant">
                </v-checkbox>
                <v-checkbox v-model="item.allergiesType" dense hide-details label="Food Allergies" multiple
                    value="Food Allergies">
                </v-checkbox>
            </v-col>
            <v-col cols="12" class="pt-4">
                <v-textarea v-model="item.allergiesConcern" auto-grow hide-details label="Food/Allergies Concern(s)"
                    outlined persistent-hint>
                </v-textarea>
            </v-col>
        </v-row>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-calendar-remove</v-icon>Need To Miss Training On Certain
            Day(s)
            <br>
            If there are certain training days that you need to miss, please provide us the dates and
            reasoning.
        </v-card-subtitle>
        <v-btn class="white--text" :color="primaryColor" @click="openAddTrainingDayMissedDialogDialog()" small>
            <v-icon left small>mdi-calendar-plus</v-icon> Add
        </v-btn>
        <v-list v-if="item.trainingDaysMissed.length > 0">
            <v-list-item v-for="(item,i) in item.trainingDaysMissed" :key="i">
                <v-list-item-icon>
                    <v-icon :color="dangerColor">mdi-calendar-alert</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ item.date }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.reason }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn :color="dangerColor" class="white--text" @click="removeTrainingDayMissed(i)" small>
                        <v-icon left small>mdi-calendar-remove</v-icon> Remove
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <v-card-subtitle class="pb-1 px-0">
            <v-icon :color="kingsGold" left>mdi-tshirt-crew</v-icon>You will receive an RA shirt
        </v-card-subtitle>
        <v-radio-group v-model="item.shirtSize" label="Shirt size" required :rules="shirtSizeRules">
            <v-radio v-for="(item, index) in shirtSizeItems" :key="index" :label="item.text" :value="item.value">
            </v-radio>
        </v-radio-group>
        <v-radio-group v-model="item.shirtStyle" class="mt-4" label="Shirt style" required :rules="shirtStyleRules">
            <v-radio v-for="(item, index) in shirtStyleItems" :key="index" :label="item.text" :value="item.value">
            </v-radio>
        </v-radio-group>
        <v-text-field v-model="item.shirtDescription" dense label="Name to appear on the shirt" outlined
            :rules="shirtDescriptionRules" required>
        </v-text-field>
        <v-dialog v-model="trainingDayMissedDialog" width="540">
            <v-card>
                <v-card-title>
                    Add Training Day Missed
                </v-card-title>
                <v-card-text>
                    <v-form ref="trainingDayMissedForm" v-model="validTrainingDayMissed" lazy-validation>
                        <v-menu ref="date" v-model="dateMenu" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="trainingDayMissed.date" id="date" label="Date" name="date"
                                    placeholder="Please select a date..." prepend-icon="mdi-calendar" readonly
                                    :rules="dateRules" v-bind="attrs" v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="trainingDayMissed.date" no-title @input="dateMenu = false">
                            </v-date-picker>
                        </v-menu>
                        <v-textarea v-model="trainingDayMissed.reason" auto-grow hide-details label="Reason" outlined
                            persistent-hint required :rules="reasonRules">
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :color="successColor" :disabled="!validTrainingDayMissed" text
                        @click="addTrainingDayMissed()">
                        Add
                    </v-btn>
                    <v-btn :color="warningColor" text @click="closeAddTrainingDayMissedDialogDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: 'applicant-ra-general-information',
    props: {
        formSettings: {
            required: true
        },
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            dateMenu: false,
            dateRules: [
                v => !!v || 'Date is required',
            ],
            firstAidTrainingInitialsRules: [
                v => !!v || 'Initials is required',
                v => (v && v.length >= 2) || 'Initials must be more atleast 2 characters'
            ],
            reasonRules: [
                v => !!v || 'Reason is required',
                v => (v && v.length >= 2) || 'Please provide a valid reason'
            ],
            shirtSizeItems: [{
                    text: 'XS',
                    value: 'XS'
                },
                {
                    text: 'S',
                    value: 'S'
                }, {
                    text: 'M',
                    value: 'M'
                },
                {
                    text: 'LG',
                    value: 'LG'
                },
                {
                    text: 'XL',
                    value: 'XL'
                },
                {
                    text: 'XXL',
                    value: 'XXL'
                }
            ],
            shirtSizeRules: [
                v => !!v || 'Shirt size is required'
            ],
            shirtStyleItems: [{
                    text: `Men's style`,
                    value: 'M'
                },
                {
                    text: 'Ladies style',
                    value: 'F'
                }
            ],
            shirtStyleRules: [
                v => !!v || 'Shirt style is required'
            ],
            shirtDescriptionRules: [
                v => !!v || 'Shirt name is required',
                v => (v && v.length >= 1) || 'Shirt name must be more atleast 1 characters'
            ],
            sinCardInitialsRules: [
                v => !!v || 'Initials is required',
                v => (v && v.length >= 2) || 'Initials must be more atleast 2 characters'
            ],
            trainingDayMissed: {
                date: '',
                reason: ''
            },
            trainingDayMissedDialog: false,
            validTrainingDayMissed: true,
        }
    },
    methods: {
        addTrainingDayMissed() {
            if (this.$refs.trainingDayMissedForm.validate()) {
                this.$emit('addTrainingDayMissed', this.trainingDayMissed);
                this.closeAddTrainingDayMissedDialogDialog();
            }
        },
        closeAddTrainingDayMissedDialogDialog() {
            this.trainingDayMissedDialog = false;
        },
        openAddTrainingDayMissedDialogDialog() {
            this.trainingDayMissed = {
                date: '',
                reason: ''
            };

            if (this.$refs.trainingDayMissedForm) {
                this.$refs.trainingDayMissedForm.resetValidation();
            }

            this.trainingDayMissedDialog = true;
        },
        removeTrainingDayMissed(index) {
            this.$emit('removeTrainingDayMissed', index);
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        kingsGold() {
            return '#d7ae28';
        },
        primaryColor() {
            return '#3699ff';
        },
        successColor() {
            return '#1bc5bd';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.col-12 {
    padding-bottom: 0;
    padding-top: 0;
}

.v-input--checkbox {
    margin-top: 0 !important;
}
</style>